import { message } from "antd";

export const useCopyToClipboard = () => {
  const copyToClipboard = async ({
    text,
    snackbarText = "Ссылка скопирована в буфер обмена",
  }: {
    text: string;
    snackbarText?: string;
  }) => {
    try {
      await window.navigator.clipboard.writeText(text);
      message.success(snackbarText);
    } catch (e) {
      message.error("Ошибка копирования в буфер обмена");
    }
  };

  return copyToClipboard;
};
